import { useFeature } from '@growthbook/growthbook-react';
import type { UseQueryOptions } from 'react-query';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQueryRecentGames } from './API/useQueryRecentGames';
import { useQueryRecentLaunchedGames } from './API/useQueryStorageGames';
import { isLoggedInSelector } from '../redux/reducers/app/params';
import FEATURES from '../constants/featureToggling';

export const useRecentGames = (options: Partial<UseQueryOptions> = {}) => {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const areRecentOnBackendEnabled = useFeature(FEATURES.RECENT_GAMES_ON_BE).on;

  const { enabled: optionsEnabled = true, ...restOptions } = options;

  const apiQuery = useQueryRecentGames({
    enabled: isLoggedIn && areRecentOnBackendEnabled && optionsEnabled,
    ...restOptions,
  });

  const localStorageQuery = useQueryRecentLaunchedGames({ ...options });

  return useMemo(() => {
    if (areRecentOnBackendEnabled) {
      return apiQuery;
    }
    return localStorageQuery;
  }, [apiQuery, localStorageQuery, areRecentOnBackendEnabled]);
};
